export { LastReportCard, type LastReportCardProps } from "./LastReportCard"
